import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const fireApp = firebase.initializeApp({
  apiKey: process.env.REACT_APP_SMALL_TALK_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_SMALL_TALK_FIREBASE_DOMAIN,
  projectId: process.env.REACT_APP_SMALL_TALK_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_SMALL_TALK_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SMALL_TALK_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_SMALL_TALK_FIREBASE_APP_ID,
});

export const fireAuth = firebase.auth();
export const db = firebase.firestore();
export const provider = new firebase.auth.GoogleAuthProvider();
export default fireApp;
